export enum StatusColors {
  Green = 'green',
  Gray = 'gray',
  Orange = 'orange',
  Primary = 'primary',
  Yellow = 'yellow',
}
